import React from "react";
import "./HouseingTransform.css";

const HouseingTransform = () => {
  return (
    <section className="wtcta-section">
      <div className="wtcta-container">
        <h2 className="wtcta-title">
          Ready to Transform Your Workplace?
        </h2>

        <p className="wtcta-text">
          Get a free site assessment and a customized housekeeping plan tailored
          to your facility’s needs.
        </p>

        <a
          href="https://wa.me/919899811123?text=Custom%20Housekeeping%20Plan"
          target="_blank"
          rel="noopener noreferrer"
          className="wtcta-button"
        >
          Get Custom Housekeeping Plan →
        </a>
      </div>
    </section>
  );
};

export default HouseingTransform;